import { Component, OnInit } from '@angular/core';
import { User } from "../../shared/models/user";
import { UserService } from "../../shared/services/user.service";
import { Role } from "../../shared/models/role";
import { Router, ActivatedRoute } from "@angular/router";
import { AlertService } from '../../shared/services/alert.service';

@Component({
  selector: 'app-user-new',
  templateUrl: './user-new.component.html',
  styleUrls: ['./user-new.component.css']
})
export class UserNewComponent implements OnInit {
  private _user:User;
  public password:string;
  public isSaving:boolean;

  public get User() {
    return this._user;
  }
  public set User(v:User) {
    this._user = v;
  }

  constructor(private userService:UserService, private router:Router
    , private route:ActivatedRoute, private alertService:AlertService) { 
    this._user = new User();
  }

  ngOnInit() {
  }

  private validateForm() {
    let errors = [];
    if (!this._user.username) {
      errors.push("You must enter an email address for this user");
    }
    else if (this._user.username.length < 3) {
      errors.push("The email address must be at least 3 characters long");
    }
    // the server will catch anything else that's not valid... we just check for '@' for a simple typo.
    else if (this._user.username.indexOf("@") < 0) {
      errors.push("The email address must be a valid email");
    }

    let passwordPolicyMsg = "Password must be 8 characters or more, contain at least one number(0-9), one uppercase letter(a-z), and one lowercase letter(A-Z)";
    let password = this.password;
    if (!password || password.length < 8) {
      errors.push(passwordPolicyMsg);
    }
    else if (!password.match(/[0-9]+/)) {
      errors.push(passwordPolicyMsg);
    }
    else if (!password.match(/[A-Z]+/)) {
      errors.push(passwordPolicyMsg);
    }
    else if (!password.match(/[a-z]+/)) {
      errors.push(passwordPolicyMsg);
    }
    return errors;
  }

  save() {
    let errors = this.validateForm();
    if (errors.length) {
      this.alertService.error(errors.join(".\n"), 3000);
      return;
    }

    // TODO: stephen need a confirm password piece here.
    this.isSaving = true;
    this._user.password = this.password;
    this.userService.createUser(this._user).then((savedUser:User) => {
      this.password = ""; // clear out the password now that we are done with it.
      this.alertService.success("User created!");
      this.isSaving = false;
      this.router.navigate(['../', savedUser.id, 'edit'], {replaceUrl: true, relativeTo: this.route});
    })
    .catch((error) => {
      this.isSaving = false;
      // TODO: stephen update this to be the more specific messages when we can...
      this.alertService.error("Failed to save new user.  Please try again");
    })
  }

  public setUserRole(role:Role) {
    this._user.role = role;
  }

}



// WEBPACK FOOTER //
// ./src/app/users/user-new/user-new.component.ts